(() => {
  'use strict';
  const $ = (id) => document.getElementById(id);
  const dataNode = $('v15-page-data');
  if (!dataNode) return;
  const data = JSON.parse(dataNode.textContent);
  const records = new Map(data.media.map(item => [item.key, item]));
  const groups = Object.fromEntries(Object.entries(data.groups).map(([key, ids]) => [key, ids.map(id => records.get(id)).filter(Boolean)]));
  const dialog = $('image-dialog');
  const enlarged = $('dialog-image');
  const thumbs = $('dialog-thumbnails');
  let collection = [];
  let selected = 0;
  let returnFocus = null;
  let savedOverflow = '';
  const revealThumbnail = () => {
    const current = thumbs.children[selected];
    if (current && !thumbs.hidden) thumbs.scrollTo({left: current.offsetLeft - thumbs.clientWidth / 2 + current.clientWidth / 2, behavior:'instant'});
  };
  const renderImage = () => {
    const item = collection[selected];
    if (!item) return;
    enlarged.src = item.src;
    enlarged.alt = item.alt || item.caption;
    if (item.key === 'dimensions') enlarged.dataset.background = 'cream';
    else delete enlarged.dataset.background;
    $('dialog-caption').textContent = item.caption || item.alt || '';
    $('dialog-counter').textContent = `${selected + 1} / ${collection.length}`;
    [...thumbs.children].forEach((button, index) => {
      button.setAttribute('aria-current', String(index === selected));
      button.classList.toggle('is-current', index === selected);
    });
    revealThumbnail();
  };
  const advance = (direction) => {
    if (collection.length < 2) return;
    selected = (selected + direction + collection.length) % collection.length;
    renderImage();
  };
  const openGallery = (items, index, trigger) => {
    if (!items.length) return;
    collection = items;
    selected = Math.max(0, Math.min(items.length - 1, index));
    returnFocus = trigger;
    thumbs.replaceChildren();
    const multiple = items.length > 1;
    $('dialog-navigation').hidden = !multiple;
    $('dialog-previous').hidden = !multiple;
    $('dialog-next').hidden = !multiple;
    thumbs.hidden = !multiple;
    dialog.classList.toggle('single-image', !multiple);
    items.forEach((item, position) => {
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'dialog-thumb';
      button.setAttribute('aria-label', `View image ${position + 1}: ${item.caption || item.alt || ''}`);
      const img = document.createElement('img');
      img.src = item.src; img.alt = ''; img.loading = 'lazy';
      button.append(img);
      button.addEventListener('click', () => { selected = position; renderImage(); });
      thumbs.append(button);
    });
    savedOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.showModal();
    renderImage();
    dialog.querySelector('.dialog-close').focus();
  };
  document.querySelectorAll('[data-zoom-target]').forEach(button => {
    button.addEventListener('click', () => {
      const img = $(button.dataset.zoomTarget);
      const key = button.dataset.mediaKey || img?.dataset.mediaKey;
      const group = groups[button.dataset.zoomGroup || (button.id === 'hero-zoom' ? 'hero' : 'explainers')];
      if (!group || !key) return;
      openGallery(group, group.findIndex(item => item.key === key), button);
    });
  });
  dialog.querySelector('.dialog-close').addEventListener('click', () => dialog.close());
  $('dialog-previous').addEventListener('click', () => advance(-1));
  $('dialog-next').addEventListener('click', () => advance(1));
  dialog.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); advance(event.key === 'ArrowLeft' ? -1 : 1); }
  });
  dialog.addEventListener('click', event => {
    if (event.target === dialog || event.target.classList.contains('dialog-image-wrap')) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.body.style.overflow = savedOverflow;
    returnFocus?.focus({preventScroll:true});
  });
  window.addEventListener('resize', revealThumbnail);
  let touch = null;
  enlarged.addEventListener('touchstart', event => {
    touch = event.touches.length === 1 && (!window.visualViewport || window.visualViewport.scale <= 1.01)
      ? {x:event.touches[0].clientX,y:event.touches[0].clientY} : null;
  }, {passive:true});
  enlarged.addEventListener('touchend', event => {
    if (!touch || !event.changedTouches.length) return;
    const dx = event.changedTouches[0].clientX - touch.x;
    const dy = event.changedTouches[0].clientY - touch.y;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) advance(dx < 0 ? 1 : -1);
    touch = null;
  }, {passive:true});

  const hoverMedia = window.matchMedia('(hover:hover) and (pointer:fine)');
  Object.values(data.pairs).forEach(config => {
    const button = $(config.buttonId), toggle = $(config.toggleId);
    const base = $(config.imageId), alternate = $(config.imageId + '-alt');
    if (!button || !toggle || !base || !alternate) return;
    let ready = false, latched = false, hovering = false;
    const render = () => {
      const second = ready && (latched || hovering);
      const key = config.ids[Number(second)], item = records.get(key);
      button.classList.toggle('is-alternate', second);
      button.dataset.mediaKey = key;
      button.dataset.zoomTarget = config.imageId + (second ? '-alt' : '');
      button.setAttribute('aria-label', `Enlarge ${item.caption}`);
      base.setAttribute('aria-hidden', String(second));
      alternate.setAttribute('aria-hidden', String(!second));
      $(config.captionId).textContent = item.caption;
      toggle.setAttribute('aria-pressed', String(latched));
      toggle.setAttribute('aria-controls', config.buttonId);
      toggle.textContent = config.labels[Number(latched)];
    };
    alternate.decode().then(() => { ready = true; toggle.hidden = false; render(); }).catch(() => {
      ready = false; latched = hovering = false; toggle.hidden = true; render();
    });
    button.addEventListener('pointerenter', event => { if (ready && hoverMedia.matches && event.pointerType === 'mouse') { hovering = true; render(); } });
    button.addEventListener('pointerleave', () => { hovering = false; render(); });
    toggle.addEventListener('click', () => { latched = !latched; render(); });
    hoverMedia.addEventListener?.('change', () => { hovering = false; render(); });
    render();
  });

  const commerce = data.commerce;
  const productForm = document.querySelector('.omt-product-form');
  const quantityInput = $('quantity');
  const purchaseButton = productForm.querySelector('.purchase-button');
  const formError = $('product-form-error');
  const minimum = Number(commerce.minimum) || 1;
  const increment = Number(commerce.increment) || 1;
  const maximum = commerce.maximum === null ? Infinity : Number(commerce.maximum);
  const normalizeQuantity = value => {
    const number = Number(value);
    const safe = Math.min(maximum, Number.isFinite(number) ? number : minimum);
    const stepped = minimum + Math.max(0, Math.floor((safe - minimum) / increment)) * increment;
    return Math.max(minimum, Math.min(maximum, stepped));
  };
  const renderQuantity = value => {
    const quantity = normalizeQuantity(value);
    quantityInput.value = String(quantity);
    $('qty-minus').disabled = !commerce.available || quantity <= minimum;
    $('qty-plus').disabled = !commerce.available || quantity + increment > maximum;
    return quantity;
  };
  $('qty-minus').addEventListener('click', () => renderQuantity(Number(quantityInput.value) - increment));
  $('qty-plus').addEventListener('click', () => renderQuantity(Number(quantityInput.value) + increment));
  quantityInput.addEventListener('change', () => renderQuantity(quantityInput.value));
  renderQuantity(quantityInput.value);
  productForm.addEventListener('submit', async event => {
    if (!window.fetch || !window.FormData) return;
    event.preventDefault();
    if (!commerce.available || purchaseButton.disabled) return;
    renderQuantity(quantityInput.value);
    if (!productForm.reportValidity()) return;
    formError.hidden = true;
    formError.textContent = '';
    const originalLabel = purchaseButton.textContent;
    purchaseButton.disabled = true;
    purchaseButton.setAttribute('aria-busy', 'true');
    purchaseButton.textContent = 'Adding…';
    try {
      const response = await fetch(commerce.addUrl, {
        method: 'POST',
        body: new FormData(productForm),
        headers: {Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
        credentials: 'same-origin'
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(typeof result.description === 'string' ? result.description : typeof result.message === 'string' ? result.message : 'This item could not be added to your cart. Please check the quantity and try again.');
      }
      window.location.assign(commerce.cartUrl);
    } catch (error) {
      formError.textContent = error.message || 'This item could not be added to your cart. Please try again.';
      formError.hidden = false;
      formError.focus({preventScroll: true});
      purchaseButton.disabled = !commerce.available;
      purchaseButton.removeAttribute('aria-busy');
      purchaseButton.textContent = originalLabel;
    }
  });
  const revealHash = () => { if (location.hash === '#delivery') $('delivery').open = true; };
  window.addEventListener('hashchange', revealHash); revealHash();
  const sticky = $('mobile-options-bar');
  let stickyFrame = null;
  const renderSticky = () => {
    stickyFrame = null;
    const visible = innerWidth <= 750 && $('options').getBoundingClientRect().bottom <= 0;
    sticky.classList.toggle('is-visible', visible);
    sticky.setAttribute('aria-hidden', String(!visible)); sticky.inert = !visible;
  };
  const queueSticky = () => { if (stickyFrame === null) stickyFrame = requestAnimationFrame(renderSticky); };
  ['scroll','resize','pageshow'].forEach(event => window.addEventListener(event, queueSticky, {passive:true}));
  new IntersectionObserver(queueSticky).observe($('options')); renderSticky();

  const reviewHost = $('judgeme_product_reviews');
  const writeReview = $('write-review');
  let waitingToWrite = false;
  const openNativeReviewForm = () => {
    const nativeWrite = reviewHost?.querySelector('button[data-testid="write-review-button"], .jdgm-write-rev-link');
    if (!nativeWrite || nativeWrite.disabled || nativeWrite.getAttribute('aria-disabled') === 'true') return false;
    waitingToWrite = false;
    writeReview?.removeAttribute('aria-busy');
    nativeWrite.click();
    return true;
  };
  const syncReviewEmptyState = () => {
    const zeroState = reviewHost?.querySelector('.jm-no-reviews-state');
    const message = zeroState?.querySelector('.jm-no-reviews-state__text');
    if (message && !message.querySelector('[data-omt-zero-copy]')) {
      const title = document.createElement('strong');
      title.dataset.omtZeroCopy = 'true';
      title.textContent = 'No customer reviews yet.';
      const detail = document.createElement('span');
      detail.textContent = 'We’d love to hear how your cat makes it their own.';
      message.replaceChildren(title, detail);
      zeroState.dataset.omtEmpty = 'true';
    }
    if (waitingToWrite) openNativeReviewForm();
  };
  writeReview?.addEventListener('click', event => {
    if (!reviewHost) return;
    event.preventDefault();
    waitingToWrite = true;
    if (!openNativeReviewForm()) {
      writeReview.setAttribute('aria-busy', 'true');
      reviewHost.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
    }
  });
  if (reviewHost) {
    const reviewObserver = new MutationObserver(syncReviewEmptyState);
    reviewObserver.observe(reviewHost, {childList: true, subtree: true});
    syncReviewEmptyState();
  }
})();
